/* Rheinkauf – kleine Seitenhilfen (nach WSTND sections/wstnd-utils.liquid)
 * 1. Entfernt ?customer_posted=true aus der Adresszeile, damit die Erfolgsmeldung
 *    beim Neuladen oder Teilen der Adresse nicht erneut erscheint.
 * 2. Blendet die Bestätigung der Newsletter-Anmeldung nach einigen Sekunden aus
 *    (Fehlermeldungen bleiben stehen).
 * 3. Merkt, wann der Fußbereich sichtbar ist (Klasse rk-fuss-sichtbar an <html>),
 *    damit der „Nach oben“-Knopf dort nichts verdeckt (Regel in assets/base.css, N6).
 * 4. Ankündigungsleiste: Knopf „Anhalten“/„Fortsetzen“, wenn sie rotiert (sections/announcement-bar.liquid);
 *    bei „Bewegung reduzieren“ steht sie von Anfang an still.
 * Cookie-Einstellungen per Link #cookie-einstellungen: assets/rk-cookie.js
 * Gesetzliche Gewährleistung (Fenster): snippets/rk-gewaehrleistung.liquid + assets/rk-recht.js (Paket A)
 */
(function () {
  'use strict';

  var AUSBLENDEN_NACH = 10000; // ms – ältere Zielgruppe: lieber etwas länger stehen lassen

  function adresseAufraeumen() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('customer_posted')) return;
      url.searchParams.delete('customer_posted');
      var rest = url.searchParams.toString();
      window.history.replaceState(window.history.state, document.title, url.pathname + (rest ? '?' + rest : '') + url.hash);
    } catch (e) { /* alte Browser: Adresse bleibt, sonst keine Folgen */ }
  }

  function bestaetigungAusblenden() {
    var meldungen = document.querySelectorAll('.newsletter-form .field__message:not(.hidden), [data-rk-ausblenden]');
    Array.prototype.forEach.call(meldungen, function (el) {
      var feld = el.closest ? el.closest('.field') : null;
      if (feld && feld.classList.contains('has-error')) return;
      if (!(el.textContent || '').trim()) return;
      setTimeout(function () {
        el.style.transition = 'opacity .4s ease';
        el.style.opacity = '0';
        setTimeout(function () { el.hidden = true; }, 450);
      }, AUSBLENDEN_NACH);
    });
  }

  function fussBeobachten() {
    var fuss = document.querySelector('body > footer');
    if (!fuss || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      var sichtbar = eintraege.some(function (e) { return e.isIntersecting; });
      document.documentElement.classList.toggle('rk-fuss-sichtbar', sichtbar);
    }, { rootMargin: '0px 0px 40px 0px' });
    io.observe(fuss);
  }

  function ankuendigung() {
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Array.prototype.forEach.call(document.querySelectorAll('[data-rk-ab-pause]'), function (knopf) {
      if (knopf.dataset.bereit) return;
      knopf.dataset.bereit = '1';
      var bereich = knopf.closest('.shopify-section') || knopf.parentNode;
      var text = knopf.querySelector('[data-rk-ab-text]');
      function setzen(angehalten) {
        knopf.setAttribute('data-angehalten', angehalten ? 'true' : 'false');
        knopf.setAttribute('aria-label', angehalten ? 'Ankündigungen fortsetzen' : 'Ankündigungen anhalten');
        if (text) text.textContent = angehalten ? 'Fortsetzen' : 'Anhalten';
        bereich.classList.toggle('is-pausiert', angehalten);
        var schieber = bereich.querySelector('announcement-bar-slider');
        var sw = schieber && (schieber.swiper || schieber.slider);
        if (sw && sw.autoplay) {
          if (angehalten) { sw.autoplay.stop(); } else { sw.autoplay.start(); }
        }
      }
      knopf.addEventListener('click', function () {
        setzen(knopf.getAttribute('data-angehalten') !== 'true');
      });
      if (ruhig) {
        setzen(true);
        /* Der Schieber startet erst mit seinem eigenen Skript (später im Dokument) – danach erneut anhalten */
        if (document.readyState === 'complete') {
          setTimeout(function () { setzen(true); }, 0);
        } else {
          window.addEventListener('load', function () { setzen(true); });
        }
      }
    });
  }

  function start() {
    adresseAufraeumen();
    bestaetigungAusblenden();
    fussBeobachten();
    ankuendigung();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', ankuendigung);
})();
